<template>
  <div>
    <modal
      class="new-modal-small"
      :name="modal_name"
      transition="nice-modal-fade"
      :delay="100"
      :height="170"
      :width="600"
      :pivot-y="0.5"
      :adaptive="true"
      :scrollable="false"
      style="border-radius: 7.5px; pointer-events:inherit !important" 
      v-bind:click-to-close="false"
    >
      <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center" style="background-color: #ffffff !important">
        <div class="w-100 bg-secondary d-flex align-items-center justify-content-center text-white" style="height: 50px">
          <p class="text-center mt-2 fw-500" style="font-size: 16px">
            UNFOLLOW CONTACT
          </p>
          <div>
            <span class="icon icon-close mr-2 mb-1 text-white pointer close-left" @click="hideSelf"></span>
          </div>
        </div>
        <div class="my-7 text-center w-100">
          <p>
            You sure you want to unfollow {{ user_name }} ?
          </p>
        </div>
        <div class="d-flex aligin-items-center justify-content-center mb-6">
          <button type="button" class="btn mx-5 btn-xlg text-secondary" style="box-shadow: none; background-color: white; border: 1px solid #00448b;" @click="hideSelf">
            Cancel
          </button>
          <button type="button" class="btn btn-new-primary btn-xlg" style="box-shadow: none;" @click="unfollowConfirm">
            Unfollow
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
export default {
  props: ["modal_name", "user_name"],
  methods: {
    hideSelf() {
      this.$modal.hide(this.modal_name);
    },
    unfollowConfirm() {
      this.$modal.hide(this.modal_name);
      this.$emit("unfollowConfirm");
    },
  },
};
</script>
<style scoped>
.btn-xlg {
  text-transform: none !important;
  border-radius: 6px;
   width:130px;
}
</style>


// WEBPACK FOOTER //
// src/components/alertModals/UnfollowModal.vue